import React, { useEffect } from 'react';

interface PreloadImageProps {
    imageUrl: string;
}

const PreloadImage: React.FC<PreloadImageProps> = ({ imageUrl }) => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.setAttribute("fetchpriority","high");
        link.href = imageUrl;
        link.as = 'image';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [imageUrl]);

    return null;
};

export default PreloadImage;